// atorhome — footer: link groups collapse on mobile (<750px), always open on larger screens; reveals the page after a newsletter post.
// Markup: sections/atorhome-footer.liquid (.ah-footer__col > h2 > button.ah-footer__col-toggle + ul.ah-footer__links).
(function () {
  if (window.atorhomeFooter) return;
  window.atorhomeFooter = true;

  const mobile = window.matchMedia('(max-width: 749px)');

  function sync() {
    document.querySelectorAll('.ah-footer__col').forEach((col) => {
      const toggle = col.querySelector('.ah-footer__col-toggle');
      const open = !mobile.matches || col.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      // On desktop the heading is not a control; keep it out of the tab order.
      toggle.tabIndex = mobile.matches ? 0 : -1;
    });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.ah-footer__col-toggle');
    if (!toggle || !mobile.matches) return;
    toggle.closest('.ah-footer__col').classList.toggle('is-open');
    sync();
  });

  // Newsletter: Shopify needs a normal form submit (its invisible CAPTCHA adds a token on submit; a fetch() post gets
  // 400 "Missing CAPTCHA token"). The page then reloads at ?customer_posted=true#AhFooterNewsletter. layout/theme.liquid
  // hides the page for that load (html.ah-nl-return) so the jump from the top down to the form isn't visible; here
  // the form is centred on screen and the page revealed.
  function revealNewsletter() {
    const root = document.documentElement;
    if (!root.classList.contains('ah-nl-return')) return;
    document.getElementById('AhFooterNewsletter')?.scrollIntoView({ block: 'center', behavior: 'instant' });
    root.classList.remove('ah-nl-return');
  }

  mobile.addEventListener('change', sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
    document.addEventListener('DOMContentLoaded', revealNewsletter);
  } else {
    sync();
    revealNewsletter();
  }
})();
